exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".doc_but{\r\n    background-color: #f5821f;\r\n    padding: 3px 17px;\r\n    color: #fff;\r\n    border-radius: 15px;\r\n    text-decoration: none;\r\n    min-width: 96px;\r\n    display: inline-block;\r\n    text-align: center;\r\n}\r\n.view_button{\r\n    background-color: #053c6d;\r\n}\r\n.view_button:hover, .doc_but:hover{color: #fff;}\r\n.right-align{text-align: end;}\r\n.status-label.custom_status {\r\n    margin-top: 0px;\r\n  }\r\n\r\n  .updated_logo{padding-top: 20px;}\r\n.updated_logo img{-o-object-fit: contain;object-fit: contain;width: 88px;}\r\n\r\n::ng-deep table.dataTable td.dataTables_empty {\r\n    display: none;\r\n}\r\n.text-primary, .text-muted {\r\n    cursor: pointer;\r\n}\r\n\r\n.bank_info1{\r\n    padding-top: 10px;\r\n}\r\n.bank_info1 p{\r\n    padding-bottom: 15px;\r\n}\r\n\r\n.addbanksec{\r\n  \r\n    background-color: #f5821f;\r\n    padding: 27px;\r\n    text-align: left;\r\n    display: inline-block;\r\n    color: #fff;\r\n    border-radius: 6px;\r\n\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/echexmerchant/echexmerchant.component.css
// module id = ../../../../../src/app/echexmerchant/echexmerchant.component.css
// module chunks = main